// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"547":"24ce6dbb","753":"71f2f19d","787":"3e092bd4"}[chunkId] + ".chunk.js";
};